import React, { Fragment, useState } from 'react';
import './horizontalGraph.scss';

import CsMadrid from './../../assets/persons/madrid/Begoña_Villacís_Cs.png';
import IUMadrid from './../../assets/persons/madrid/carlos-sanchez-mato_IU.png';
import PPMadrid from './../../assets/persons/madrid/Jose-Luis-Martinez-Almeida_PP.png';
import MMMadrid from './../../assets/persons/madrid/Manuela_Carmena_MAS_MADRID.png';
import VOXMadrid from './../../assets/persons/madrid/ortegasmith_VOX.png';
import PSOEMadrid from './../../assets/persons/madrid/pepuhernandez_PSOE.png';

import CUPBcn from './../../assets/persons/barcelona/Anna-Saliente_CUP.png';
import BComuBcn from './../../assets/persons/barcelona/Colau_B-comú.png';
import ERCBcn from './../../assets/persons/barcelona/Ernest-Maragall_ERC.png';
import PSCBcn from './../../assets/persons/barcelona/jaume-collboni_PSC.png';
import JxCatBcn from './../../assets/persons/barcelona/Joaquin-Forn_JxCAT.png';
import CsBcn from './../../assets/persons/barcelona/Manuel-Valls_CS.png';
import PPBcn from './../../assets/persons/barcelona/José-Bou-Vila_PP.png';

const partiesPhotos = {
  28079: {
    //Madrid
    1003592: CsMadrid, //Cs
    1003521: PPMadrid, //PP
    1021626: IUMadrid, //M en pie
    1022563: MMMadrid, //Mas madrid
    1027165: VOXMadrid, //Vox
    1002046: PSOEMadrid //PSOE
  },
  '08019': {
    //BCN
    1003133: CUPBcn, //CUP
    1003464: BComuBcn, //Bcomu
    1030943: ERCBcn, //ERC
    1002046: PSCBcn, //PSC
    1003149: JxCatBcn, //JxCat
    1003126: CsBcn, //Cs
    1003521: PPBcn //PP
  }
};

const HorizontalGraph = ({
  data,
  leyend = true,
  dataKey = 'seats',
  total = 1,
  place = null,
  showFaces = false,
  showLabel,

  label,
  labelAbrv
}) => {
  const [mousePos, setMousePos] = useState({ x: null, y: null });
  const [selectedParty, setSelectedParty] = useState();

  const mouseEnter = (e, party) => {
    setMousePos({ x: e.clientX, y: e.clientY });
    setSelectedParty(party);
  };

  const mouseLeave = () => {
    setMousePos({ x: null, y: null });
  };

  if (!data) {
    return <div>Cargando...</div>;
  }
  return (
    <Fragment>
      {leyend && (
        <div className="horizontalGraphLeyend">
          <ul className="leyendParties">
            {data.map(party => {
              if (party[dataKey] > 0) {
                return (
                  <li
                    className="leyendParty"
                    key={`${party.partyAcronym}-${party.id}`}
                    style={{
                      width: (party[dataKey] / total) * 100 + '%'
                    }}
                  >
                    {showFaces && partiesPhotos[place][party.id] && (
                      <span
                        className="partyCircle"
                        style={{
                          backgroundColor: party.partyColor
                        }}
                      >
                        <img
                          src={partiesPhotos[place][party.id]}
                          alt={party.partyAcronym}
                        />
                      </span>
                    )}
                    <span className="leyendParty_txt">
                      {party.partyAcronym}
                    </span>
                  </li>
                );
              }
              return <li></li>;
            })}
          </ul>
        </div>
      )}
      <div className="horizontalGraph">
        <div className="horizontalGraph_container">
          <div className="horizontalGraph_bars">
            <div className="horizontalGraph_bar">
              {data.map(party => {
                return (
                  <div
                    className="horizontalGraph_bar_content"
                    key={party.partyAcronym}
                    style={{
                      backgroundColor: party.partyColor,
                      width: (party[dataKey] / total) * 100 + '%'
                    }}
                    onMouseMove={e => mouseEnter(e, party)}
                    onMouseLeave={() => mouseLeave()}
                  >
                    <span className="horizontalGraph_bar_txt">
                      {party[dataKey]}
                    </span>
                  </div>
                );
              })}
            </div>

            {showLabel && (
              <div className="horizontalGraph_line">
                <div className="horizontalGraph_line_txt">
                  Mayoría absoluta
                  <span className="horizontalGraph_line_number">
                    {Math.trunc(total / 2 + 1)}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
        {mousePos.x && (
          <div
            className="horizontalGraph_tooltip"
            style={{
              position: 'fixed',
              left:
                mousePos.x < window.innerWidth / 2
                  ? mousePos.x + 15
                  : mousePos.x - 170,
              top: mousePos.y - 5,
              borderLeft: '10px solid ' + selectedParty.partyColor
            }}
          >
            <h3 className="partyName">{selectedParty.partyAcronym}</h3>
            <p className="partySeats">
              {selectedParty[dataKey]} {label || 'escaños'}
            </p>
            <p className="partyVotes">
              {Number(selectedParty.votesPercent).toLocaleString('de')} %{' '}
            </p>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default HorizontalGraph;
